module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.3ec2bc48.svg";